export default "__VITE_ASSET__ka342OjQ__"